// Libs
import classNames from 'classnames/bind';
import { Box, Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useState } from 'react';
// Components, Layouts, Pages
import { BaseTab } from '~/components/common';
import { FormNote, NoteListTab } from '~/components/module/job';
// Others
import { JobTabEnum } from '~/utils/enum/common';
import { tabNoteJob } from '~/utils/constants/component';
// Styles, images, icons
import styles from './NoteJobTab.module.scss';
import { icons } from '~/assets';

type Props = {};

const cx = classNames.bind(styles);

const NoteJobTab = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/jobs', 'common/base']);
  const { id: jobId } = useParams();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [currentTab, setCurrentTab] = useState<string>(JobTabEnum.INTERNAL_NOTES);
  const [isOpenNoteFormModal, setIsOpenNoteFormModal] = useState<boolean>(false);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleChangeTab = (tab: string) => {
    setCurrentTab(tab);
  };

  const renderTabContent = () => {
    switch (currentTab) {
      case JobTabEnum.INTERNAL_NOTES:
        return <NoteListTab id={jobId} type={currentTab} />;

      case JobTabEnum.EXTERNAL_NOTES:
        return <NoteListTab id={jobId} type={currentTab} />;

      case JobTabEnum.SITE_NOTES:
        return <NoteListTab id={jobId} type={currentTab} />;

      default:
        return (
          <Box className={cx('noData')}>
            {t('common_no_data_available', {
              ns: 'common/base',
            })}
          </Box>
        );
    }
  };

  const handleAddNote = () => {
    handleShowNoteFormModal();
  };

  const handleShowNoteFormModal = () => {
    setIsOpenNoteFormModal(!isOpenNoteFormModal);
  };
  //#endregion Handle Function

  return (
    <Stack id='noteJobTabComponent' className={cx('container')}>
      <Box className={cx('body')}>
        <BaseTab
          onChange={handleChangeTab}
          items={tabNoteJob}
          enableUrlSync={false}
          childrenAction={
            currentTab !== JobTabEnum.SITE_NOTES && (
              <Button
                type='button'
                variant='contained'
                className={cx('buttonAction')}
                onClick={handleAddNote}
                startIcon={<img src={icons.commonIconPlus} alt={'common_alt_img'} />}
              >
                {t('note_tab_add_note')}
              </Button>
            )
          }
        />

        <Box className={cx('tabContent')}>{renderTabContent()}</Box>
      </Box>

      {isOpenNoteFormModal && <FormNote onClose={handleShowNoteFormModal} type={currentTab} />}
    </Stack>
  );
};

export default NoteJobTab;
